// extracted by mini-css-extract-plugin
module.exports = {"main":"DeleteAccountPanel_main__3GoE4","content":"DeleteAccountPanel_content__1KORu"};